export * from '@/graphql/queries/auth';
export * from '@/graphql/queries/country';
export * from '@/graphql/queries/createEditProject';
export * from '@/graphql/queries/language';
export * from '@/graphql/queries/projects';
export * from '@/graphql/queries/tasks';
export * from '@/graphql/queries/user';
